import { render } from "./App.vue?vue&type=template&id=774edd3f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=774edd3f&lang=css"
script.render = render

export default script